import { render, staticRenderFns } from "./FormCreateConsignment.vue?vue&type=template&id=0c72fe46&scoped=true"
import script from "./FormCreateConsignment.vue?vue&type=script&lang=js"
export * from "./FormCreateConsignment.vue?vue&type=script&lang=js"
import style0 from "./FormCreateConsignment.vue?vue&type=style&index=0&id=0c72fe46&prod&lang=css&scoped=true"
import style1 from "./FormCreateConsignment.vue?vue&type=style&index=1&id=0c72fe46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72fe46",
  null
  
)

export default component.exports